// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_1Uk1yqG_UJABYvXRUalrrx"};